import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "backgroundsSpritesheets/desktop/33_winter_night/33_winter_night"
 * Contains 1 texture(s)
 */
export class Desktop33WinterNightAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'backgroundsSpritesheets/desktop/33_winter_night/33_winter_night';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '33_winter_night.png'
    ] as const;
}
